// extracted by mini-css-extract-plugin
export default {"tree":"Products_tree__pelSz","product":"Products_product__opTOU","colorContainer":"Products_colorContainer__3LZHp"};